import React from 'react';
import { useState, useEffect,useMemo } from 'react';
import Select from 'react-select';
// import { useWidgetSetupStore } from 'src/context/stores';

const MultiSelectBtn = ({data, placeholder, name, setMultiSelect, index, isMulti=true, deviceDetail, needsFields=true,handleDeviceChange, isSpecialType=false}) => {
    const [dataOptions, setDataOptions] = useState([])
    const [defaultItem, setDefaultItem] = useState()
    const [fields, setFields]= useState([])
    let selectedDevices = Array.isArray(deviceDetail) ? [...new Set(deviceDetail?.map(el => Number(el?.device ?? el)))] : [deviceDetail];
    
    //can be refactored and moved to a diff location (widgetSetup component )
    const items = useMemo(() => {
      return data?.map((device, index) => ({
        index: index,
        value: device?.id,
        label: `${device?.id}. ${device?.name}`,
        property: device?.property
      }));
    }, [data]);
    
    useEffect(() => {
      let device_data = items?.filter(item => selectedDevices?.includes(item.value))
      setDefaultItem(device_data);
      if(deviceDetail && needsFields){
        handleChange(device_data)
      }
      setDataOptions(items);
    }, [deviceDetail, items]);
    

    const handleSelectChange = (_data) => {
      if(isSpecialType){
        let selectedDevices= _data?.map(d => d.value) ?? []
        handleDeviceChange(selectedDevices, "device")
      }
      handleChange(_data)

    }

    const handleChange = (_data) => {
        let deviceIds = []
        let deviceIndexes = []
        if(isMulti){ //supports multiple selected devices
          deviceIds= _data?.map(d => d.value) ?? []
          deviceIndexes = _data?.map(d => d.index) ?? []

          
        }else{
          //some widget single device is not an array
          deviceIds= Array.isArray(_data) ? [_data?.[0].value] : [_data?.value]
          deviceIndexes = Array.isArray(_data) ? [_data?.[0].index] : [_data?.index]
          // deviceIndexes.push(_data?.index)
          // console.log("we got here", _data)
        }
        getFieldsOfSelectedDevice(deviceIds, deviceIndexes)

    }

    const getFieldsOfSelectedDevice = (deviceIds, deviceIndex) => {
      if (deviceIndex && Array.isArray(deviceIndex)) {
        let fields = [];
          deviceIndex?.forEach((device_index) => {
            const selectedDeviceProperties = data?.[device_index]?.property;
            if (selectedDeviceProperties) {
              const parsedProperty = JSON.parse(selectedDeviceProperties);
              if (parsedProperty) {
                fields = fields?.concat(parsedProperty.map((n) => ({ name: n.name, field: n.field, unit: n.unit })));
              }
            }
          });
        
      
          // Count the occurrences of each field in the array
          const fieldCounts = fields?.reduce((acc, field) => {
            const key = `${field.name}-${field.field}`;
            acc[key] = (acc[key] || 0) + 1;
            return acc;
          }, {});
      
          // get all the common fields (those that are repeating more than once)
          if(deviceIds?.length > 1){
            const uniqueFields = {};
            fields = fields.filter((field) => {
              const key = `${field.name}-${field.field}`;
              if (fieldCounts[key] > 1 && !uniqueFields[key]) {
                uniqueFields[key] = true;
                return true;
              }
              return false;
            });
          }
        
        setMultiSelect({
          data: deviceIds, //list of deviceIds
          field: name?.split("-")[0], //field name
          index: index, 
          deviceFields: fields, //list of intersection fields from each device
          info: (fields?.length ===0 && deviceIds?.length>1)?"Please Select devices that are similar":
                (deviceIds?.length === 0)?"Please select a device" :'select device field',
          isEmpty: fields?.length ===0 
        });
      }
    }

    const customStyles = {
        control: (baseStyles, state) => ({
          ...baseStyles,
        cursor: "pointer",
        boxShadow: state.isFocused ? 0 : 0,
        borderWidth:"1.5px",
        minHeight:"45px",
        borderColor: state.isFocused
          ? "var(--VekinBrandColor)"
          : "",
        "&:hover": {
          borderColor: state.isFocused
            ? "var(--VekinBrandColor)"
            : ""
        }}),
        singleValue: (provided, state) => ({
          ...provided,
          backgroundColor: "var(--Vekin80)",
        }),
        multiValue: (provided, state) => ({
          ...provided,
          backgroundColor: "var(--Vekin80)",
        }),

        option: (provided, state) => ({
          ...provided,
          "&:hover": {
            backgroundColor: state.isFocused ? "var(--Vekin80)" : "transparent",
          },
          backgroundColor: state.isFocused ? "var(--Vekin80)" : "transparent",
        })
      }
   
    return (
      <>
      {defaultItem && 
       <Select
            hideSelectedOptions={true}
            defaultValue={defaultItem}
            styles={customStyles}
            isMulti={isMulti}
            name={name}
            options={dataOptions}
            className="text-sm basic-multi-select focus:border-vekin focus:border"
            classNamePrefix="select"
            placeholder={placeholder}
            onChange={handleSelectChange}
            required
            
      />
}
      
      </>
       
     );
}
 
export default MultiSelectBtn;